import Model from './model'

export default class Article extends Model {
  constructor() {
    super()
    this.hydrate({
      category_id: '',
      title: '',
      slug: '',
      sub_title: '',
      author: '',
      active: false,
      short_description: '',
      body: '',
      file: ''
    })
  }
}
